import styled from "styled-components";

import { AssetsService } from "app/services/AssetsService";

export const LockedPageContainer = styled.div`
    position: relative;
    height: 100%;
    background-image: url(${AssetsService.assetUrl("/images/website-content/website-content-mock-blurred.svg")});
    background-position: left top;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const BannerOverlay = styled.div`
    position: sticky;
    top: 83px;
    z-index: 10;
    height: 0;
`;
